/**
 * Real SHA-256 over whatever bytes the caller gives it, computed in-browser
 * via SubtleCrypto — evidence/photo attachment forms need a genuine 64-hex-char
 * digest (grievances.ts's `evidenceItem` schema is `z.string().length(64)`)
 * and this portal has no file-upload/object-storage wiring of its own yet,
 * so the hash is taken over the docRef+label text the officer/worker types
 * rather than real file bytes — real crypto, honestly a text-content hash
 * not a file hash, never a fabricated placeholder string.
 */
export async function sha256Hex(input: string): Promise<string> {
  const bytes = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}
